var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialMax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3021 27.9227C11.5512 27.9227 10.2734 27.518 8.05755 25.8993C6.64748 27.7204 2.20917 29.1367 2.01439 26.7087C2.01439 24.8897 1.6074 23.3569 1.15929 21.6692C0.610483 19.6023 0 17.303 0 13.9613C0 5.99277 6.5102 0 14.2291 0C21.948 0 28 6.28536 28 14.0388C28 21.7921 21.7554 27.9227 14.3021 27.9227ZM14.4142 6.88886C10.658 6.69115 7.72674 9.30758 7.08036 13.4028C6.5451 16.7941 7.49412 20.9265 8.30594 21.1345C8.68849 21.2324 9.66889 20.4362 10.2732 19.8292C11.2671 20.4762 12.4078 20.9774 13.6757 21.0441C17.5319 21.2472 20.9492 18.2174 21.1512 14.3461C21.3532 10.4748 18.2705 7.09188 14.4142 6.88886Z",
    fill: "#073AE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMax);
export default __webpack_public_path__ + "static/media/social-max.4f84f0262297c8ef4c31d01cdc4dd640.svg";
export { ForwardRef as ReactComponent };